type GetContactCardActionModeArgsType = {
  contactCard: unknown | null;
};

export type ContactCardActionModeType = 'create' | 'open';

export const getContactCardActionMode = ({
  contactCard,
}: GetContactCardActionModeArgsType): ContactCardActionModeType => {
  return contactCard === null ? 'create' : 'open';
};
